import React from "react"
import { connect } from "react-redux"
import { Carousel } from "react-responsive-carousel"
import { REGISTER } from "../../constants/routes"
import { Link } from "gatsby"
import "react-responsive-carousel/lib/styles/carousel.min.css"
import Slider1 from "../images/slider_1.jpg"
import Slider2 from "../images/slider_2.jpg"
import Slider3 from "../images/slider_3.jpg"

const HomeCarousel = () => {
  return (
    <div className="sliderLarge">
      <Carousel autoPlay infiniteLoop={true} showThumbs={false}>
        <div>
          <img src={Slider1} alt="Slider1" />
          <Link
            to={REGISTER}
            className="legend button button-reg button-3d button-circle gradient-grey-orange mr-0 text-center mb-3 mt-5"
          >
            Register Now!
          </Link>
        </div>
        <div>
          <img src={Slider2} alt="Slider2" />
        </div>
        <div>
          <img src={Slider3} alt="Slider3" />
        </div>
      </Carousel>
    </div>
  )
}

export default connect()(HomeCarousel)
